import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { OpportunitiesShell } from "@/components/CandidateHeader";
import { CompanyLogo } from "@/pages/candidate/Companies";
import { JobCard } from "@/pages/candidate/Jobs";
import { ArrowLeft, MapPin, Loader2, Briefcase } from "lucide-react";

export default function CandidateCompanyDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/candidate/companies/${id}`).then((r) => setData(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return (
    <OpportunitiesShell>
      <button onClick={() => nav("/app/companies")} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900 mb-4"><ArrowLeft size={16} /> Firmy</button>
      <div className="rounded-3xl border border-dashed border-slate-300 bg-white p-12 text-center"><p className="font-semibold text-slate-800">Firma sa nenašla</p></div>
    </OpportunitiesShell>
  );
  if (!data) return <OpportunitiesShell><div className="flex justify-center py-20"><Loader2 className="animate-spin text-blue-700" /></div></OpportunitiesShell>;

  const { company, jobs } = data;
  return (
    <OpportunitiesShell>
      <button onClick={() => nav("/app/companies")} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900 mb-4"><ArrowLeft size={16} /> Firmy</button>

      <div className="rounded-3xl bg-white border border-slate-200 shadow-sm p-6" data-testid="company-detail">
        <div className="flex items-start gap-4">
          <CompanyLogo logo={company.logo} name={company.name} size={64} />
          <div className="min-w-0">
            <h1 className="font-head text-2xl font-bold tracking-tight">{company.name}</h1>
            {company.location && <p className="text-sm text-slate-500 inline-flex items-center gap-1 mt-0.5"><MapPin size={14} /> {company.location}</p>}
          </div>
        </div>
        {company.description && <p className="mt-4 text-slate-700 leading-relaxed">{company.description}</p>}
      </div>

      <h2 className="mt-8 font-head text-xl font-bold tracking-tight flex items-center gap-2"><Briefcase size={20} className="text-blue-700" /> Aktuálne pracovné ponuky</h2>
      {jobs.length === 0 ? (
        <div className="mt-4 rounded-3xl border border-dashed border-slate-300 bg-white p-10 text-center" data-testid="company-no-jobs">
          <p className="font-semibold text-slate-800">Momentálne nemáme otvorené pracovné pozície.</p>
          <p className="text-sm text-slate-500 mt-1">Firmu si môžete pozrieť aj neskôr.</p>
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="company-jobs-list">
          {jobs.map((j) => <JobCard key={j.id} j={j} showCompany={false} />)}
        </div>
      )}
    </OpportunitiesShell>
  );
}
